export default {
  pager: (state) => state.pager,
  isChecked: (state) => state.isChecked,
  workout: (state) => state.workout,
  workouts: (state) => state.workouts,
  classes: (state) => state.classes,
}
